import { CombinedGraphQLErrors } from "@apollo/client/errors";
import { GlobalGraphQLErrors } from "@sa-nu/shared-types";

const SUPPRESS_KEY = "suppressUnauthenticatedAlert";

/**
 * 未ログインのエラーを呼び出し側で扱う操作に渡す context。
 * error link の「ログインが必要です」ダイアログを出さないようにする
 */
export const suppressUnauthenticatedAlertContext = { [SUPPRESS_KEY]: true };

export function suppressesUnauthenticatedAlert(
  context: Record<string, unknown>,
): boolean {
  return context[SUPPRESS_KEY] === true;
}

export function hasGraphQLErrorCode(error: unknown, code: string): boolean {
  return (
    CombinedGraphQLErrors.is(error) &&
    error.errors.some((e) => e.extensions?.["code"] === code)
  );
}

export function isUnauthenticatedError(error: unknown): boolean {
  return hasGraphQLErrorCode(error, GlobalGraphQLErrors.UNAUTHENTICATED);
}
